module.exports = __webpack_public_path__ + "img/T6-C-rc_16.252ee386.png";